export const PROFILE_ACCORDION_HEADER_MAX_CHARACTERS = 60;
export const PROFILE_ACCORDION_HEADER_SUFFIX = '...';
export const PROFILE_ACCORDION_LOCATIONS_MIN_VALUE = 4;
export const RESTAURANT_NAMES_SEPARATOR = ', ';
